import { array, eq, string } from 'fp-ts';
import { isEqual } from 'lodash';

export const eqUniversal = eq.fromEquals(isEqual);
export const eqStringArray = array.getEq(string.Eq);
